import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import renderHTML from 'react-render-html';
// import Iframe from 'react-iframe';
import Parser from 'rss-parser';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import { isAuthenticated } from '../../auth/Auth';
import DetailPostModal from '../../components/molecules/DetailPostModal';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  dateStyle: {
    color: 'rgba(0, 0, 0, 0.5)',
    fontSize: 12,
    marginBottom: 5
  },
  titlePost: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 14
  },
  textContain: {
    padding: '5px 15px 15px 15px',
    backgroundColor: '#ffffff'
  },
  listPosts: {
    padding: 15
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  itemPost: {
    backgroundColor: '#ffffff',
    marginBottom: 15,
    padding: 0,
    cursor: 'pointer'
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('rssItems', 'setRssItems', []),
  withState('openDetailPost', 'setDetailPost', false),
  withState('content', 'setContent', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const parser = new Parser();
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/fa6608d1-ee67-4ee1-a563-36842e0302c0.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssItems(feed.items);
        }
      );
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    name,
    handleRedirect,
    rssItems,
    openDetailPost,
    setDetailPost,
    content,
    setContent
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    const dateFormat = timeStr => {
      if (!timeStr) {
        return null;
      }
      const date = new Date(timeStr);
      const day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      return `${year}/${month}/${day}`;
    };

    console.log(rssItems);

    const actionOpenDetail = params => {
      setContent(params);
      setDetailPost(true);
    };
    return (
      <div className={classes.root}>
        <Header name={name} />
        <Typography variant="h5" className={classes.titlePage}>
          新着記事
        </Typography>
        {rssItems && (
          <List
            component="nav"
            className={classes.listPosts}
            aria-label="contacts"
          >
            {rssItems.map((item, index) => {
              const params = {
                title: item.title,
                content: item.content,
                pubDate: dateFormat(item.pubDate)
              };
              return (
                <>
                  <ListItem
                    className={classes.itemPost}
                    onClick={() => actionOpenDetail(params)}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                  >
                    <div>
                      <img
                        className={classes.imageFig}
                        src={item.enclosure && item.enclosure.url}
                        alt={item.enclosure && item.enclosure.caption}
                        width="100%"
                      />
                      <div className={classes.textContain}>
                        <div className={classes.dateStyle}>
                          {dateFormat(item.pubDate)}
                        </div>
                        <div className={classes.titlePost}>{item.title}</div>
                      </div>
                    </div>
                  </ListItem>
                </>
              );
            })}
          </List>
        )}
        <MenuBox account={account} />

        <Modal
          open={openDetailPost}
          onClose={() => {
            setDetailPost(false);
          }}
          className={classes.modalMobile}
        >
          <DetailPostModal
            setDetailPost={setDetailPost}
            params={content}
            // textTitle={textTitle}
            // textMessage={textMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
